export default class AssinaturasController {
    constructor($state, CoreAssinaturaMes, UIService) {
        this.$state = $state;
        this.CoreAssinaturaMes = CoreAssinaturaMes;
        this.UI = UIService;
        this.dataLoaded = false;
        this.meses = [
            { name: "janeiro", value: 1 },
            { name: "fevereiro", value: 2 },
            { name: "março", value: 3 },
            { name: "abril", value: 4 },
            { name: "maio", value: 5 },
            { name: "junho", value: 6 },
            { name: "julho", value: 7 },
            { name: "agosto", value: 8 },
            { name: "setembro", value: 9 },
            { name: "outubro", value: 10 },
            { name: "novembro", value: 11 },
            { name: "dezembro", value: 12 }
        ];
        this.anos = this.generateYearArray();
        this.filtersLoaded = [1, 1];
        this.opt = $state.params;
        this.displayColumns = [
            { displayName: 'ID SGI', name: 'id', visible: false, sortable: true, width: 100 },
            { displayName: 'Ano', name: 'ano', visible: true, sortable: true, width: 100 },
            { displayName: 'Mês', name: 'mes', visible: true, sortable: false, width: 150 },
            { displayName: 'Nº Total de Assinaturas', name: 'nAssinaturas', visible: true, sortable: true, width: 250 },
            { displayName: 'Nº Assinaturas Acima Pacote Base', name: 'nAssinaturasExtra', visible: true, sortable: true, width: 275 },
            { displayName: 'Nº Blocos Extra', name: 'nBlocosExtra', visible: true, sortable: true, width: 200 },
            { displayName: 'Custo Sem IVA', name: 'custo', visible: true, sortable: true, width: 200 },
        ];
        // type 's': select, 'o': plain text, 'd': date
        this.equalityFilters = [{
                val: 'a',
                name: 'Igual',
                type: 'o'
            },
            {
                val: 'b',
                name: 'Diferente',
                type: 'o'
            },
            {
                val: 'c',
                name: 'Começa por',
                type: 'o'
            },
            {
                val: 'd',
                name: 'Termina com',
                type: 'o'
            },
            {
                val: 'e',
                name: 'Contém',
                type: 'o'
            },
            {
                val: 'a',
                name: 'Igual (=)',
                type: 'd'
            },
            {
                val: 'b',
                name: 'Diferente de (≠)',
                type: 'd'
            },
            {
                val: 'c',
                name: 'Posterior a (>)',
                type: 'd'
            },
            {
                val: 'd',
                name: 'Anterior a (<)',
                type: 'd'
            },
            {
                val: 'e',
                name: 'Posterior ou igual (≥)',
                type: 'd'
            },
            {
                val: 'f',
                name: 'Anterior ou igual (≤)',
                type: 'd'
            },
            {
                val: 'a',
                name: 'Igual',
                type: 's'
            },
            {
                val: 'b',
                name: 'Diferente',
                type: 's'
            }
        ];
        this.dateFilters = this.equalityFilters.filter(x => x.type === 'd');
        this.columns = [{
                id: 'CoreAssinaturaMes.ano',
                name: 'Ano',
                type: 's',
                list: this.anos
            },
            {
                id: 'CoreAssinaturaMes.mes',
                name: 'Mês',
                type: 's',
                list: this.meses
            },
            {
                id: 'CoreAssinaturaMes.nAssinaturas',
                name: 'Nº Total Assinaturas',
                type: 'o'
            },
            {
                id: 'CoreAssinaturaMes.nAssinaturasExtra',
                name: 'Nº Assinaturas Acima...',
                type: 'o'
            },
            {
                id: 'CoreAssinaturaMes.nBlocosExtra',
                name: 'Nº Blocos Extra',
                type: 'o'
            },
            {
                id: 'CoreAssinaturaMes.custo',
                name: 'Custo S/ IVA',
                type: 'o'
            }
        ];
        // Find relevant displayColumns from local storage
        if (localStorage.getItem('AssinaturasDisplayColumns')) {
            let cols = JSON.parse(localStorage.getItem('AssinaturasDisplayColumns'));
            if (cols && cols.length > 0) {
                cols.forEach(c => {
                    let i = this.displayColumns.findIndex(x => x.name === c.name);
                    if (i >= 0)
                        this.displayColumns[i].visible = c.visible;
                });
            }
        }
        this.customFilters = [];
        // Find customFilters from local storage
        if (localStorage.getItem('AssinaturasFilter')) {
            this.customFilters = JSON.parse(localStorage.getItem('AssinaturasFilter'));
        }
        // Check if something comes from the URL, replace the customFilters if so
        if (this.opt.filter) {
            this.customFilters = [];
            let filters = this.opt.filter.split(":");
            filters.forEach(filter => {
                let a = filter.split("·");
                if (a.length === 3) {
                    try {
                        let data = {
                            column: {},
                            value: {}
                        };
                        data.column.selected = this.columns.find(f => {
                            return f.id === a[0];
                        });
                        if (angular.isUndefined(data.column.selected)) {
                            throw Error();
                        }
                        this.customFilters.push(data);
                    }
                    catch (e) {
                        this.customFilters = [];
                        this.UI.addToast('Não foi possível carregar filtros');
                    }
                }
            });
            // If updated, save it to local storage
            localStorage.setItem('AssinaturasFilter', JSON.stringify(this.customFilters));
        }
        // Restore list to selected if exists
        this.customFilters.forEach(f => {
            if (f.column && f.column.selected) {
                if (f.column && f.column.selected) {
                    if (f.column.selected.id === 'CoreAssinaturaMes.ano')
                        f.column.selected.list = this.anos;
                    if (f.column.selected.id === 'CoreAssinaturaMes.mes')
                        f.column.selected.list = this.meses;
                }
            }
            // Fix date filters to be moment()
            if (f.column.selected.type === 'd') {
                f.value = moment(f.value).utc();
                f.value.second(0); // We don't care about seconds
            }
        });
        // Number of selected items
        this.nSelected = 0;
        this.everythingSelected = false;
        // Load the data for the filter panel (not mandatory just to look at the table)
        this.loadData();
        // Load the table data so we can see stuff even if nothing else works
        this.getAssinaturasMes();
    }
    // Just a small function to give a year choice
    generateYearArray = () => {
        const currentYear = new Date().getFullYear();
        const startYear = 2023;
        const yearsArray = [];
        for (let year = currentYear; year >= startYear; year--) {
            yearsArray.push({ name: year.toString(), value: year });
        }
        return yearsArray;
    };
    // Add entry to whereObject (where/whereLiteral) or to whereOrObject depending if there are multiple selections of the same entry
    setWhereField = (data, whereObject, whereOrObject) => {
        // Check if have this entry in whereOr already
        if (whereOrObject.find(x => x.key === data.key)) { // If so, add it here then
            whereOrObject.push({
                key: data.key,
                value: data.value
            });
        }
        else { // Not in OR, check if there's an entry of this key in whereObject already
            if (whereObject[data.key]) { // Already have an entry for this key, transform it into an OR and add it and the new one
                whereOrObject.push({
                    key: data.key,
                    value: whereObject[data.key]
                });
                delete whereObject[data.key];
                whereOrObject.push({
                    key: data.key,
                    value: data.value
                });
            }
            else { // It's the first entry of this key, use whereObject only
                whereObject[data.key] = data.value;
            }
        }
    };
    // Returns a whereFields object to use in table() remote methods (ativo, interacao)
    // WhereLiteral should be defined locally
    setWhereFields = (customFilters, literal, orsLiteral) => {
        let where = {};
        let whereDates = [];
        let whereNextDates = [];
        let whereLiteral = literal || {};
        let whereOrLiteral = orsLiteral || [];
        let whereOr = [];
        customFilters.forEach(f => {
            let data = {};
            data.key = f.column.selected.id;
            // Generated dates - Assuming if no . exists in field, it's always generated date
            if (f.column.selected.id.split('.').filter(Boolean).length === 1 && f.column.selected.type === 'd') {
                whereNextDates.push({
                    key: data.key,
                    comp: f.values.selected.val,
                    value: f.value,
                    format: f.column.selected.format
                });
            }
            else { // All other cases where fields exist in database
                if (f.column.selected.type === 'o') {
                    data.value = f.value;
                    this.setWhereField(data, where, whereOr);
                }
                else {
                    if (f.column.selected.type === 'd') {
                        whereDates.push({
                            key: data.key,
                            comp: f.values.selected.val,
                            value: f.value,
                            format: f.column.selected.format
                        });
                    }
                    else {
                        // if ID doesn't exist, use value (Yes/No cases where id doesn't exist but value does)
                        if (f.value.selected.id)
                            data.value = f.value.selected.id;
                        else
                            data.value = f.value.selected.value;
                        this.setWhereField(data, whereLiteral, whereOrLiteral);
                    }
                }
            }
        });
        return {
            where: where,
            whereDates: whereDates,
            whereNextDates: whereNextDates,
            whereLiteral: whereLiteral,
            whereOr: whereOr,
            whereOrLiteral: whereOrLiteral
        };
    };
    clearFilter = () => {
        localStorage.removeItem('AssinaturasFilter');
        this.customFilters = [];
        this.getAssinaturasMes();
    };
    getAssinaturasMes = () => {
        this.tableLoading = true;
        let whereFields = this.setWhereFields(this.customFilters);
        this.CoreAssinaturaMes.table({
            params: {
                fields: [
                    'CoreAssinaturaMes.id as id',
                    'CoreAssinaturaMes.ano as ano',
                    'CoreAssinaturaMes.mes as mes',
                    'CoreAssinaturaMes.nAssinaturas as nAssinaturas',
                    'CoreAssinaturaMes.nAssinaturasExtra as nAssinaturasExtra',
                    'CoreAssinaturaMes.nBlocosExtra as nBlocosExtra',
                    'CoreAssinaturaMes.custo as custo',
                ],
                from: ['CoreAssinaturaMes'],
                referencesOrigin: [undefined],
                references: [undefined],
                aliases: [],
                where: whereFields.where,
                whereLiteral: whereFields.whereLiteral,
                whereDates: whereFields.whereDates,
                whereOr: whereFields.whereOr,
                whereOrLiteral: whereFields.whereOrLiteral,
                order: this.opt.order,
                sort: this.opt.sort,
                limit: this.opt.items,
                skip: (this.opt.page - 1) * this.opt.items,
            }
        }).$promise.then(res => {
            let page = this.opt.page;
            let items = this.opt.items;
            let total = res.count;
            this.start = total > 0 ? (page - 1) * items + 1 : 0;
            if ((this.start - 1 + items) >= total) {
                this.end = total;
            }
            else {
                this.end = Number.parseInt(this.start - 1 + items);
            }
            // Process output
            res.data.forEach(i => {
                i.mesExtenso = moment.months(i.mes - 1);
                console.log(i);
            });
            this.assinaturasMes = res.data;
            this.total = total;
            this.tableLoading = false;
        }).catch((error) => {
            console.log(error);
            this.UI.addToast("Não foi possível obter assinaturas. Verifique a ligação");
        });
    };
    isColumnVisible = (column) => {
        let f = this.displayColumns.find(x => x.name === column);
        return _.isEmpty(f) ? false : f.visible;
    };
    selectVisibleColumns = () => {
        let options = {
            size: 'md',
            template: require('./columns.dialog.html'),
            controller: ['$dialog', '$scope', (dialog, scope) => {
                    scope.title = "Editar Campos Visíveis";
                    scope.displayColumns = angular.copy(this.displayColumns);
                    scope.ok = () => {
                        dialog.close(scope);
                    };
                    scope.cancel = () => {
                        dialog.dismiss('cancel');
                    };
                }]
        };
        let modal = this.UI.showDialog(options);
        modal.then((res) => {
            if (res && res.displayColumns) {
                this.displayColumns = angular.copy(res.displayColumns);
                // Save it to local storage
                localStorage.setItem('AssinaturasDisplayColumns', JSON.stringify(this.displayColumns));
            }
        });
    };
    loadData = () => {
        // No data necessary to load
    };
    sort = key => {
        if (!key.sortable) {
            return;
        }
        let keyname = key.name;
        if (this.opt.order === keyname)
            this.opt.page = 1;
        this.opt.order = keyname;
        this.opt.sort = this.opt.sort === 'asc' ? 'desc' : 'asc';
        this.$state.go('app.consultas.assinaturas', this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: 'replace',
            // inherit the current params on the url
            inherit: true
        });
        this.getAssinaturasMes();
    };
    item = val => {
        this.opt.items = val;
        this.$state.go('app.consultas.assinaturas', this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: 'replace',
            // inherit the current params on the url
            inherit: true
        });
        this.getAssinaturasMes();
    };
    page = sum => {
        this.opt.page += sum;
        if (this.opt.page < 1)
            this.opt.page = 1;
        if (this.opt.page > Math.ceil(this.total / this.opt.items))
            this.opt.page = Math.ceil(this.total / this.opt.items);
        this.$state.go('app.consultas.assinaturas', this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: 'replace',
            // inherit the current params on the url
            inherit: true
        });
        this.getAssinaturasMes();
    };
    openFilter = () => {
        let result = this.filtersLoaded.reduce((a, b) => a + b, 0);
        if (result !== this.filtersLoaded.length) {
            this.UI.addToast("A carregar dados para filtragem, por favor tente novamente");
            return;
        }
        // if (!this.funcionarios.length) {
        //   this.UI.addToast("Erro ao carregar dados de filtragem. Por favor recarregue a página.");
        //   return;
        // }
        this.columns.forEach(f => {
            if (f.id === 'CoreAssinaturaMes.ano')
                f.list = this.anos;
            if (f.id === 'CoreAssinaturaMes.mes')
                f.list = this.meses;
        });
        // Copy column to be used in
        this.editColumns = angular.copy(this.columns);
        // Restore list to selected
        this.customFilters.forEach(f => {
            if (f.column && f.column.selected) {
                if (f.column.selected.id === 'CoreAssinaturaMes.ano')
                    f.column.selected.list = this.anos;
                if (f.column.selected.id === 'CoreAssinaturaMes.mes')
                    f.column.selected.list = this.meses;
            }
        });
        console.log(this.customFilters);
        // Copy customFilter to another variable so we can edit it all we want
        this.editCustomFilters = angular.copy(this.customFilters);
        // Show side panel
        this.fs = true;
    };
    oldColumn = ($item, i) => {
        //Infinite Scroll Magic
        i.infiniteScroll = {};
        i.infiniteScroll.numToAdd = 20;
        i.infiniteScroll.currentItems = 20;
        if ($item.type === 's')
            i.value = {};
        else
            i.value = "";
        i.addMoreItems = function () {
            i.infiniteScroll.currentItems += i.infiniteScroll.numToAdd;
        };
    };
    applyFilter = () => {
        // Parse values from sidebar
        this.editCustomFilters = _.filter(this.editCustomFilters, f => f.column && !_.isEmpty(f.value));
        // Remove list for column, no need to save it
        this.editCustomFilters.forEach(f => {
            if (f.column && f.column.selected) {
                f.column.selected.list = [];
            }
            // Fix date filters to be moment()
            if (f.column.selected.type === 'd') {
                f.value = moment(f.value).utc();
                f.value.second(0); // We don't care about seconds
            }
        });
        this.customFilters = angular.copy(this.editCustomFilters);
        localStorage.setItem('AssinaturasFilter', JSON.stringify(this.customFilters));
        this.fs = false;
        // Go to first page for results
        this.opt.page = 1;
        this.$state.go('app.consultas.assinaturas', this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: 'replace',
            // inherit the current params on the url
            inherit: true
        });
        this.getAssinaturasMes();
    };
}
AssinaturasController.$inject = ['$state', 'CoreAssinaturaMes', 'UIService'];
